module.exports = __webpack_public_path__ + "img/wechat-116.60924d67.png";